import { render, staticRenderFns } from "./info-page3.vue?vue&type=template&id=fa78943a&"
import script from "./info-page3.vue?vue&type=script&lang=js&"
export * from "./info-page3.vue?vue&type=script&lang=js&"
import style0 from "./info-page3.vue?vue&type=style&index=0&id=fa78943a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports